<template>
    <FaqThemes :id="id"/>
</template>
<script>
import FaqThemes from '@/components/FaqThemes.vue';

export default {
    name: 'FaqThemeProfile',
    components: {
        FaqThemes
    },
    data() {
        return {
            id: null,
        }   
    },
    mounted() {
        this.id = this.$route.params.id ? +this.$route.params.id : null;
    },
}
</script>
